<template>
	<div ref="chart" style="width: 800px; height: 200px"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
	data() {
		return {
			myChart: null,
		};
	},
	mounted() {
		let chartDom = this.$refs.chart,
			option = {
				dataset: [
					{
						source: [
							[170, 250, 402],
							[195, 232, 250],
							[195, 250, 260],
						],
					},
					{
						transform: {
							type: "boxplot",
						},
					},
					{
						fromDatasetIndex: 1,
						fromTransformResult: 1,
					},
				],
				tooltip: {},
				grid: {
					left: "10%",
					right: "10%",
					bottom: "15%",
				},
				yAxis: {
					type: "category",
					boundaryGap: true,
					nameGap: 30,
					splitArea: {
						show: false,
					},
					splitLine: {
						show: false,
					},
				},
				xAxis: {
					type: "value",
					name: "km/s minus 299,000",
					splitArea: {
						show: true,
					},
				},

				series: [
					{
						name: "weizen",
						type: "boxplot",
						datasetIndex: 2,
					},
					{
						name: "bohne",
						type: "boxplot",
						datasetIndex: 1,
					},
					{
						name: "outlier",
						type: "scatter",
						encode: { x: 1, y: 0 },
						datasetIndex: 2,
					},
				],
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
		console.log(option, this.myChart);
	},
	methods: {
		getChartData() {
			return [
				{ value: 1048, name: "Search Engine" },
				{ value: 735, name: "Direct" },
				{ value: 580, name: "Email" },
				{ value: 484, name: "Union Ads" },
				{ value: 300, name: "Video Ads" },
			];
		},
	},
};
</script>
